import React, { PropsWithChildren } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, ButtonProps } from 'reactstrap';

type BackButtonProps = PropsWithChildren<ButtonProps>;

export const BackButton: React.FC<BackButtonProps> = (props: Readonly<BackButtonProps>): JSX.Element => {
  const { children, ...buttonProps } = props;
  const history = useHistory();
  return (
    <Button {...buttonProps} onClick={() => history.goBack()}>
      {children}
    </Button>
  )
}
